import React from "react";
import FormField from "@ingka/form-field";
import Select, { OptGroup, Option } from '@ingka/select';
import '@ingka/svg-icon/style.scss';
import '@ingka/button/style.scss';
import '@ingka/forms/style.scss';
import '@ingka/focus/style.scss';
import '@ingka/text/style.scss';
import '../score-access.scss';

interface OptionProps {
  countries: Record<string, string>,
  currentCountry: string,
  handleCountryChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
}

export const DateInputSection: React.FC<OptionProps> = ({
  countries,
  currentCountry,
  handleCountryChange,
}) => {
  
  const countryOptions = Object.keys(countries).map(country => 
    (<Option name={country} value={country} data-bucode={country}/>)
  )
  return(
    <div className="scenario-section">
      <FormField
        valid={currentCountry ? "success" : "error"}
        shouldValidate={true}
        validation={{
          id: "country-validation-id",
          msg: "Please select a country",
          type: "error",
        }}
      >
        <Select
          id="country-dropdown"
          label="Country *"
          value={currentCountry}
          onChange={handleCountryChange}
          required={true}
        >
          <OptGroup>{countryOptions}</OptGroup>
        </Select>
      </FormField>
    </div>
  )
}